import React from 'react';
const BankOfAmerica = () => {
  return (
    <svg
      fill='#000000'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 55 55'
      width='40px'
      height='40px'
    >
      <path d='M24.928 38C32.507 31.503 43.153 25.188 49 22.914c-.902-.578-2.31-1.408-3.898-2.31-7.543 2.49-16.349 8.012-24.217 14.256C22.221 35.87 23.628 36.917 24.928 38L24.928 38zM21.463 20.352c-1.119-.542-2.346-1.047-3.284-1.48-2.851 1.407-6.569 3.537-11.26 6.893 1.011.542 2.093 1.191 3.248 1.841C13.776 24.935 17.421 22.409 21.463 20.352zM28.212 17.248c-1.372-.758-6.135-2.527-9.42-3.284-.974.361-2.346.902-3.284 1.299 1.191.325 5.63 1.516 9.42 3.429C25.902 18.222 27.274 17.645 28.212 17.248L28.212 17.248zM12.079 16.779C7.857 18.728 3.418 21.398 1 22.95c.866.397 1.732.722 2.923 1.299 5.341-3.609 9.528-5.811 11.188-6.532C13.92 17.283 12.801 16.995 12.079 16.779L12.079 16.779zM31.388 16.129c.974-.325 2.094-.614 3.068-.903-2.815-1.191-6.352-2.454-9.528-3.248-.505.144-2.021.542-3.068.866C22.943 13.17 26.515 14 31.388 16.129zM13.595 29.699c1.155.686 2.382 1.624 3.573 2.418 7.904-6.135 15.699-10.863 24.253-13.534-1.191-.613-2.238-1.154-3.573-1.804C32.723 18.078 23.953 21.578 13.595 29.699L13.595 29.699z' />
    </svg>
  );
};
export default BankOfAmerica;
